import React from 'react';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import { Bar } from 'react-chartjs-2';

import { isCoordenadorOuApoioSecretarial } from '../../security/AuthorizedFunction';

const CORES = {
    recebidas: '#6a1b9a',
    digitalizadas: '#283593',
    cortadas: '#0277bd',
    leitura: '#00838f',
    digitadas: '#2e7d32',
    emRevisao: '#ef6c00',
    revisadas: '#558b2f',
    descartadas: '#757575',
    finalizadas: '#1b5e20',
};

const ETAPAS_ADMIN = [
    { rotulo: 'Recebidas', campo: 'recebidas' },
    { rotulo: 'Digitalizadas', campo: 'digitalizadas' },
    { rotulo: 'Cortadas', campo: 'cortadas' },
    { rotulo: 'Leitura de Marcações Realizadas', campo: 'leitura' },
    { rotulo: 'Digitadas', campo: 'digitadas' },
    { rotulo: 'Em Revisão pela OBMEP Central', campo: 'emRevisao' },
    { rotulo: 'Revisadas', campo: 'revisadas' },
    { rotulo: 'Descartadas', campo: 'descartadas' },
    { rotulo: 'Finalizadas', campo: 'finalizadas' },
];

const ETAPAS_COORD = [
    { rotulo: 'Recebidas', campo: 'recebidas' },
    { rotulo: 'Digitalizadas', campo: 'digitalizadas' },
    { rotulo: 'Leitura de Marcações Realizadas', campo: 'leitura' },
    { rotulo: 'Digitadas', campo: 'digitadas' },
    { rotulo: 'Em Revisão pela OBMEP Central', campo: 'emRevisao' },
    { rotulo: 'Finalizadas', campo: 'finalizadas' },
];

const CONVERSAO = '#546e7a';
const FONTE_ANOTACAO = '600 12px Roboto, Helvetica, Arial, sans-serif';

const medirLarguraMaxima = textos => {
    if (typeof document === 'undefined')
        return 0;

    const ctx = document.createElement('canvas').getContext('2d');

    if (!ctx)
        return 0;

    ctx.font = FONTE_ANOTACAO;

    return textos.reduce((maior, texto) => Math.max(maior, ctx.measureText(texto).width), 0);
};

const PLUGIN_CONVERSAO = {
    id: 'conversaoEtapas',
    afterDatasetsDraw(chart) {
        const meta = chart.getDatasetMeta(0);

        if (!meta || !meta.data)
            return;

        const valores = chart.data.datasets[0].data.map(v => Number(v) || 0);
        const base = valores[0] ?? 0;

        const { ctx } = chart;
        ctx.save();
        ctx.font = FONTE_ANOTACAO;
        ctx.textBaseline = 'middle';
        ctx.fillStyle = CONVERSAO;

        meta.data.forEach((barra, i) => {
            if (i === 0 || base <= 0)
                return;

            ctx.fillText(percentual((valores[i] / base) * 100), barra.x + 8, barra.y);
        });

        ctx.restore();
    },
};

const percentual = valor => `${valor.toLocaleString('pt-BR', { maximumFractionDigits: 0 })}%`;

export const Funil = ({ visaoGeral }) => {
    const dados = visaoGeral ?? null;
    const etapas = isCoordenadorOuApoioSecretarial() ? ETAPAS_COORD : ETAPAS_ADMIN;
    const valoresEtapas = etapas.map(e => dados?.[e.campo] ?? 0);
    const base = valoresEtapas[0] ?? 0;
    const anotacoes = base > 0 ? valoresEtapas.slice(1).map(v => percentual((v / base) * 100)) : [];
    const paddingDireita = Math.ceil(medirLarguraMaxima(anotacoes)) + 16;

    return (
        <Grid item xs={12} lg={6}>
            <Card style={{ height: '100%' }}>
                <CardContent>
                    <Typography variant="h6" gutterBottom>Etapas</Typography>

                    { !dados ?
                        <Typography variant="body2" color="textSecondary">Sem dados para exibir.</Typography>
                    :
                        <>
                            <div style={{ height: 320 }}>
                                <Bar
                                    plugins={[PLUGIN_CONVERSAO]}
                                    data={{
                                        labels: etapas.map(e => e.rotulo),
                                        datasets: [
                                            {
                                                label: 'Quantidade',
                                                data: etapas.map(e => dados[e.campo] ?? 0),
                                                backgroundColor: etapas.map(e => CORES[e.campo]),
                                                borderWidth: 1,
                                            },
                                        ],
                                    }}
                                    options={{
                                        indexAxis: 'y',
                                        responsive: true,
                                        maintainAspectRatio: false,
                                        layout: {
                                            padding: { right: paddingDireita },
                                        },
                                        plugins: {
                                            legend: { display: false },
                                        },
                                        scales: {
                                            x: { beginAtZero: true, ticks: { precision: 0 } },
                                        },
                                    }}
                                />
                            </div>

                            <Typography variant="caption" color="textSecondary" style={{ display: 'block', marginTop: 8 }}>
                                O percentual ao lado de cada barra é a proporção em relação às provas recebidas.
                            </Typography>
                        </>
                    }
                </CardContent>
            </Card>
        </Grid>
    );
}

export default Funil;
